var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path4, _path5, _path6, _path7, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 839,
    height: 837,
    viewBox: "0 0 839 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.957031 441.259L261.526 331.317L680.15 558.269L728.999 835.958L0.957031 441.259Z",
    fill: "url(#paint0_linear_644_16818)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.957031 441.259L261.526 331.317L680.15 558.269L728.999 835.958L0.957031 441.259Z",
    fill: "url(#paint1_linear_644_16818)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_644_16818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 331,
    width: 730,
    height: 505
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.961914 441.259L261.531 331.317L680.155 558.269L729.004 835.958L0.961914 441.259Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_644_16818)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter0_f_644_16818)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 492.358,
    ry: 152.33,
    transform: "matrix(0.476603 -0.879119 -0.879119 -0.476603 300.39 287.82)",
    fill: "url(#paint2_diamond_644_16818)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 516.575,
    ry: 146.763,
    transform: "matrix(0.109524 0.993984 0.96096 -0.276688 292.544 283.219)",
    fill: "url(#paint3_diamond_644_16818)",
    fillOpacity: 0.35
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_644_16818)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 278.61,
    ry: 152.05,
    transform: "matrix(0.476603 -0.879119 -0.879119 -0.476603 297.633 292.989)",
    fill: "url(#paint4_diamond_644_16818)",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 283.641,
    ry: 476.877,
    transform: "matrix(0.879119 0.476603 0.476603 -0.879119 299.89 288.09)",
    fill: "url(#paint5_diamond_644_16818)",
    fillOpacity: 0.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.951172 441.259L728.993 835.958",
    stroke: "url(#paint6_linear_644_16818)",
    strokeWidth: 1.38025
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M838.04 388.935L578.527 501.346L157.767 278.38L106.283 1.16681L838.04 388.935Z",
    fill: "url(#paint7_linear_644_16818)",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M838.04 388.935L578.527 501.346L157.767 278.38L106.283 1.16681L838.04 388.935Z",
    fill: "url(#paint8_linear_644_16818)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_644_16818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 1,
    width: 733,
    height: 501
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M838.034 388.935L578.521 501.346L157.761 278.38L106.277 1.16684L838.034 388.935Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_644_16818)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter2_f_644_16818)"
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 492.358,
    ry: 152.33,
    transform: "matrix(-0.468234 0.883605 0.883605 0.468234 540.088 545.225)",
    fill: "url(#paint9_diamond_644_16818)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 516.575,
    ry: 146.763,
    transform: "matrix(-0.118957 -0.992899 -0.958289 0.285801 547.965 549.753)",
    fill: "url(#paint10_diamond_644_16818)",
    fillOpacity: 0.35
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter3_f_644_16818)"
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 278.61,
    ry: 152.05,
    transform: "matrix(-0.468234 0.883605 0.883605 0.468234 542.781 540.022)",
    fill: "url(#paint11_diamond_644_16818)",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 283.641,
    ry: 476.877,
    transform: "matrix(-0.883605 -0.468234 -0.468234 0.883605 540.572 544.947)",
    fill: "url(#paint12_diamond_644_16818)",
    fillOpacity: 0.3
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M838.034 388.935L106.277 1.16675",
    stroke: "url(#paint13_linear_644_16818)",
    strokeWidth: 1.38025
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_644_16818",
    x: 8.08664,
    y: -173.211,
    width: 584.607,
    height: 922.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0372,
    result: "effect1_foregroundBlur_644_16818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_644_16818",
    x: -67.3772,
    y: -139.101,
    width: 730.02,
    height: 864.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.298,
    result: "effect1_foregroundBlur_644_16818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_644_16818",
    x: 251.015,
    y: 82.2253,
    width: 578.146,
    height: 926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0372,
    result: "effect1_foregroundBlur_644_16818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_644_16818",
    x: 178.918,
    y: 107.091,
    width: 727.726,
    height: 865.862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.298,
    result: "effect1_foregroundBlur_644_16818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_644_16818",
    x1: 532.569,
    y1: 474.418,
    x2: 425.132,
    y2: 672.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2335D2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_644_16818",
    x1: 112.756,
    y1: 394.322,
    x2: 655.845,
    y2: 778.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(492.358 152.33) rotate(90.0137) scale(165.868 536.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#0E00A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(516.575 146.763) rotate(90) scale(146.763 516.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF29FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353727,
    stopColor: "#3422FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.61 152.05) rotate(90.0078) scale(165.564 303.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#3422FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(283.641 476.877) rotate(90) scale(476.877 283.641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353727,
    stopColor: "#DF29FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_644_16818",
    x1: 1.18947,
    y1: 440.82,
    x2: 729.232,
    y2: 835.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_644_16818",
    x1: 306.137,
    y1: 360.825,
    x2: 411.687,
    y2: 161.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2335D2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_644_16818",
    x1: 726.692,
    y1: 436.931,
    x2: 179.977,
    y2: 57.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(492.358 152.33) rotate(90.0137) scale(165.868 536.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#0E00A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(516.575 146.763) rotate(90) scale(146.763 516.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF29FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353727,
    stopColor: "#3422FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.61 152.05) rotate(90.0078) scale(165.564 303.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#3422FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_diamond_644_16818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(283.641 476.877) rotate(90) scale(476.877 283.641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353727,
    stopColor: "#DF29FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_644_16818",
    x1: 837.8,
    y1: 389.376,
    x2: 106.043,
    y2: 1.60856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrism);
export default __webpack_public_path__ + "static/media/prism.8931d240.svg";
export { ForwardRef as ReactComponent };